export const Home = {};

S.import('@main')
  .then(() => {
    initCountUp();
  });

function initCountUp() {
  const numbers = document.querySelectorAll('.j-static-card-number') as NodeListOf<HTMLDivElement>;
  const countUpItems = [];

  numbers.forEach((target: HTMLDivElement) => {
    const num = target.dataset.num ?? '0';

    const decimals = countDecimals(parseFloat(num))

    const options = {
      decimalPlaces: decimals,
    };

    //@ts-ignore
    const item = new window.countUp.CountUp(target.id, num, options);

    let observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            item.start();
          }
        });
      }
    );

    observer.observe(target);
  });
}

function countDecimals (value: number): number {
  if (Math.floor(value) === value) {
    return 0;
  }

  return value.toString().split('.')[1].length || 0;
}
